<!-- src/app/meter/components/meter-list/meter-inventory/meter-inventory.component.html -->

<div class="inventory-container">
    <div class="filter-bar">
        <div class="search-container">
            <mat-icon class="search-icon">search</mat-icon>
            <input type="text"
                   class="search-input"
                   #searchInput
                   [placeholder]="'meter.manage.search_placeholder' | translate"
                   (input)="onSearchChange(searchInput.value)">
        </div>

        <mat-form-field class="filter-field" appearance="outline" *ngIf="!isSearchMode">
            <mat-label>{{ 'meter.manage.filter_status' | translate }}</mat-label>
            <mat-select [value]="selectedStatus" (selectionChange)="onStatusChange($event.value)">
                <mat-option value="">{{ 'meter.manage.filter_status_all' | translate }}</mat-option>
                <mat-option *ngFor="let s of statusOptions" [value]="s">
                    {{ 'meter.manage.status_' + s.toLowerCase() | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="filter-field" appearance="outline" *ngIf="!isSearchMode">
            <mat-label>{{ 'meter.manage.filter_node_type' | translate }}</mat-label>
            <mat-select [value]="selectedNodeType" (selectionChange)="onNodeTypeChange($event.value)">
                <mat-option value="">{{ 'meter.manage.filter_status_all' | translate }}</mat-option>
                <mat-option *ngFor="let t of nodeTypeOptions" [value]="t">{{ t }}</mat-option>
            </mat-select>
        </mat-form-field>

        <button class="add-meter-button" (click)="openLinkDialog()">
            {{ 'meter.manage.link_add_button' | translate }}
        </button>
    </div>

    <div class="table-container">
        <mat-progress-spinner *ngIf="loading" mode="indeterminate" diameter="40" class="spinner"></mat-progress-spinner>

        <table mat-table [dataSource]="meters" *ngIf="!loading">
            <ng-container matColumnDef="nodeId">
                <th mat-header-cell *matHeaderCellDef (click)="onSortChange('nodeId')" class="sortable">
                    {{ 'meter.manage.col_meter_id' | translate }}
                    <mat-icon *ngIf="sortBy === 'nodeId'" class="sort-icon">
                        {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                </th>
                <td mat-cell *matCellDef="let meter">{{ meter.nodeId }}</td>
            </ng-container>

            <ng-container matColumnDef="nodeType">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_type' | translate }}</th>
                <td mat-cell *matCellDef="let meter">{{ meter.nodeType }}</td>
            </ng-container>

            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_address' | translate }}</th>
                <td mat-cell *matCellDef="let meter">{{ formatAddress(meter) }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_status' | translate }}</th>
                <td mat-cell *matCellDef="let meter">
                    <span class="status-chip" [attr.data-status]="meter.status">
                        {{ 'meter.manage.status_' + meter.status.toLowerCase() | translate }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="users">
                <th mat-header-cell *matHeaderCellDef>{{ 'meter.manage.col_users' | translate }}</th>
                <td mat-cell *matCellDef="let meter">{{ getUserNames(meter) }}</td>
            </ng-container>

            <ng-container matColumnDef="lastMeterReadAt">
                <th mat-header-cell *matHeaderCellDef (click)="onSortChange('lastMeterReadAt')" class="sortable">
                    {{ 'meter.manage.col_last_reading' | translate }}
                    <mat-icon *ngIf="sortBy === 'lastMeterReadAt'" class="sort-icon">
                        {{ sortOrder === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                    </mat-icon>
                </th>
                <td mat-cell *matCellDef="let meter">
                    {{ meter.lastMeterReadAt ? (meter.lastMeterReadAt | date:'mediumDate') : ('meter.manage.never' | translate) }}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="!loading && meters.length === 0" class="no-results">
            <p>{{ 'meter.manage.no_results' | translate }}</p>
        </div>
    </div>

    <mat-paginator *ngIf="!isSearchMode"
        [length]="total"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 20, 50]"
        (page)="onPageChange($event)"
        showFirstLastButtons>
    </mat-paginator>
</div>
